import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'sidebar-collapsed';

/**
 * 데스크톱 사이드바 접힘 상태. 관리자/유저 레이아웃이 같은 키를 공유하므로
 * 역할이 바뀌어도 사용자가 마지막에 고른 상태가 유지된다.
 *
 * lg 미만에서는 사이드바가 아예 hidden 이고 햄버거 드로어(sidebarOpen)가 따로 있으므로
 * 이 값은 데스크톱에서만 의미가 있다.
 */
export default function useSidebarCollapsed() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true';
    } catch (e) {
      // 시크릿 모드 등 localStorage 접근이 막힌 환경 — 기본값(펼침)으로 둔다.
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(collapsed));
    } catch (e) {
      // 저장 실패해도 화면 동작에는 영향 없음
    }
  }, [collapsed]);

  const toggle = useCallback(() => setCollapsed((prev) => !prev), []);

  return [collapsed, setCollapsed, toggle];
}
